import React from 'react';
import { classNames } from '../atoms';

interface TopNavProps extends React.HTMLAttributes<HTMLElement> {
  innerClassName?: string;
}

const TopNav = React.forwardRef<HTMLElement, TopNavProps>(({
  className,
  innerClassName,
  children,
  ...props
}, ref) => (
  <nav
    ref={ref}
    className={classNames('navbar navbar-expand-lg navbar-dark bg-primary shadow-sm', className)}
    {...props}
  >
    <div className={classNames('container-fluid', innerClassName)}>
      {children}
    </div>
  </nav>
));

TopNav.displayName = 'TopNav';

export default TopNav;
